export default {
  pageBackground: "#ffffff",
  cardBackground: "#f5f5f5",
  colorPrimary: "#009ef7",
  colorError: "#b02a37",
  colorSuccess: "#50cd89",
  colorTextBase: "#181C32",
  fontFamily: "body-font",
  colorWarning: "#ffc700",
  sideBarBackgroundColor: "#1e1e2d",
  sidebarColorDefault: "#9D9DA6",
  inputBackgroundColor: "#F9F9F9",
  colorWhite: "#fff",
  // fontSize: "14px",
};
